import PageHero, { usePageTitle } from "@/components/PageHero";
import SectionHeader from "@/components/SectionHeader";
import ServicesGrid from "@/components/ServicesGrid";
import CTABand from "@/components/CTABand";
import { Reveal } from "@/components/Reveal";
import { RESULTS_BAR } from "@/data/content";

export default function Servicios() {
  usePageTitle("Servicios de Procurement | BRIK Procurement Partners");
  return (
    <>
      <PageHero
        eyebrow="Servicios"
        titleLines={["Todo el ciclo de Procurement.", "Una visión estratégica."]}
        description="Soluciones a la medida de tu negocio. Te acompañamos en cada etapa de la función de Compras, desde la estrategia hasta la ejecución."
        image="/brand/ref-boardroom-map.webp"
        alt="Estrategia de procurement global — sala de juntas BRIK"
      />

      <section data-testid="services-list" className="bg-white">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 lg:py-32">
          <SectionHeader
            eyebrow="Capacidades"
            title="Doce capacidades. Un solo objetivo: generar valor."
            description="De la estrategia a la ejecución, integramos las capacidades necesarias para construir una función de Compras más sólida, estratégica y eficiente."
          />
          <div className="mt-14">
            <ServicesGrid variant="rows" />
          </div>
        </div>
      </section>

      <section data-testid="results-band" className="relative bg-oxford diagonal-lines overflow-hidden">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 lg:py-24">
          <Reveal>
            <p className="eyebrow text-center">Lo que entregamos</p>
          </Reveal>
          <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
            {RESULTS_BAR.map((r, i) => (
              <Reveal key={r.label} delay={i * 0.1}>
                <div className="group flex flex-col items-center text-center gap-6" data-testid={`result-item-${i + 1}`}>
                  <div className="flex h-24 w-24 items-center justify-center rounded-full bg-white/[0.03] ring-1 ring-gold/40 transition-all duration-300 group-hover:ring-gold group-hover:bg-white/[0.06] group-hover:-translate-y-1">
                    <r.icon className="h-10 w-10 text-gold" strokeWidth={1.25} />
                  </div>
                  <p className="font-display text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase text-white max-w-[200px]">{r.label}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTABand
        title="Construimos la solución que tu empresa necesita."
        text="Podemos intervenir en una necesidad específica, desarrollar una capacidad determinada o acompañarte en la transformación integral de tu función de Compras."
        cta="Solicitar diagnóstico"
      />
    </>
  );
}
